import { render, staticRenderFns } from "./BoardListDonateLayout.vue?vue&type=template&id=4bdcdd26&scoped=true&"
import script from "./BoardListDonateLayout.vue?vue&type=script&lang=js&"
export * from "./BoardListDonateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bdcdd26",
  null
  
)

export default component.exports